if (!customElements.get("category-product-tabs")) {
  class CategoryProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.addEventListener("click", this.handleClick);
    this.addEventListener("keydown", this.handleKeydown);
    this.addEventListener("shopify:block:select", this.handleBlockSelect);
    const selectedIndex = this.tabs.findIndex((tab) => tab.getAttribute("aria-selected") === "true");
    this.activate(selectedIndex < 0 ? 0 : selectedIndex, false);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    this.removeEventListener("keydown", this.handleKeydown);
    this.removeEventListener("shopify:block:select", this.handleBlockSelect);
  }

  handleClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.contains(tab)) this.activate(this.tabs.indexOf(tab));
  };

  handleBlockSelect = (event) => {
    const selectedBlock = event.target.closest("[data-group-id]");
    if (!selectedBlock) return;

    const tab = this.tabs.find((item) => item.dataset.groupId === selectedBlock.dataset.groupId);
    const index = this.tabs.indexOf(tab);
    if (index >= 0) this.activate(index, false);
  };

  handleKeydown = (event) => {
    const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
    if (index < 0) return;

    let nextIndex;
    if (event.key === "ArrowRight") nextIndex = (index + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;
    if (nextIndex === undefined) return;

    event.preventDefault();
    this.activate(nextIndex);
  };

  activate(index, focus = true) {
    if (index < 0 || index >= this.tabs.length) return;

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active.toString());
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
    if (focus) {
      this.tabs[index].focus();
      this.tabs[index].scrollIntoView({ behavior: "auto", block: "nearest", inline: "center" });
    }
  }
  }

  customElements.define("category-product-tabs", CategoryProductTabs);
}
